import Controller from "./captain.controller";
import template from "./captain.html";

const captain = {
  template,
  controller: Controller,
};

export default captain;



// WEBPACK FOOTER //
// ./src/pages/captain/captain.component.js